import { ArrowUpRight, ArrowDownLeft, CreditCard, Send } from "lucide-react";

const BALANCES = [
  { ccy: "USD", value: "124,860.20", change: "+3.1%" },
  { ccy: "EUR", value: "58,430.10", change: "+1.4%" },
  { ccy: "GBP", value: "31,208.55", change: "-0.6%" },
  { ccy: "INR", value: "84,12,400", change: "+5.2%" },
];

const TRANSFERS = [
  { label: "P2P · A. Sharma", detail: "Wallet transfer", amt: "₹12,500", status: "Completed", dir: "out" },
  { label: "Wire · Vendor-2213", detail: "International wire", amt: "$8,900", status: "Processing", dir: "out" },
  { label: "ACH · Payroll batch", detail: "42 recipients", amt: "$42,300", status: "Completed", dir: "out" },
  { label: "Card · •• 4412", detail: "Virtual card issued", amt: "—", status: "Active", dir: "in" },
];

const STATUS = {
  Completed: "bg-emerald-50 text-emerald-600 border-emerald-100",
  Processing: "bg-blue-50 text-blue-600 border-blue-100",
  Active: "bg-teal-50 text-teal-600 border-teal-100",
};

export default function WalletMock() {
  return (
    <div
      data-testid="wallet-dashboard-mockup"
      className="overflow-hidden rounded-2xl border border-[#E2E8F0] bg-white shadow-[0_32px_80px_-32px_rgba(11,18,32,0.35)]"
      role="img"
      aria-label="iJeeva Wallet Platform dashboard mockup showing multi-currency balances, transfers and card issuance with fictional demo data"
    >
      <div className="flex items-center gap-3 border-b border-[#E2E8F0] bg-[#F8FAFC] px-4 py-3">
        <div className="flex gap-1.5">
          <span className="h-2.5 w-2.5 rounded-full bg-[#E2E8F0]" />
          <span className="h-2.5 w-2.5 rounded-full bg-[#E2E8F0]" />
          <span className="h-2.5 w-2.5 rounded-full bg-[#E2E8F0]" />
        </div>
        <div className="font-mono-brand mx-auto rounded-md border border-[#E2E8F0] bg-white px-3 py-1 text-[11px] text-[#64748B]">
          wallet.ijeeva.com
        </div>
        <span className="rounded-full border border-[#0EA5A4]/30 bg-[#0EA5A4]/10 px-2.5 py-0.5 text-[10px] font-semibold text-[#0EA5A4]">
          DEMO TENANT
        </span>
      </div>

      <div className="p-4 sm:p-5">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-[13px] font-semibold text-[#1D305B]">Meridian Fintech · Master wallet</p>
            <p className="text-[11px] text-[#94A3B8]">Tenant: meridian-prod</p>
          </div>
          <span className="flex items-center gap-1.5 rounded-lg bg-[#1D305B] px-3 py-1.5 text-[11px] font-semibold text-white">
            <Send className="h-3 w-3" /> Disburse
          </span>
        </div>

        <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {BALANCES.map((b) => (
            <div key={b.ccy} className="rounded-xl border border-[#E2E8F0] bg-white p-3">
              <p className="font-mono-brand text-[10.5px] font-semibold text-[#64748B]">{b.ccy}</p>
              <p className="font-mono-brand mt-1 text-[14px] font-semibold text-[#1D305B]">{b.value}</p>
              <p className={`mt-0.5 text-[10px] font-medium ${b.change.startsWith("-") ? "text-rose-500" : "text-[#0EA5A4]"}`}>
                {b.change}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-3 grid gap-3 lg:grid-cols-5">
          <div className="overflow-hidden rounded-xl border border-[#E2E8F0] bg-white lg:col-span-3">
            <div className="border-b border-[#F1F5F9] px-3.5 py-2.5">
              <p className="text-[11px] font-semibold text-[#334155]">Recent transfers</p>
            </div>
            {TRANSFERS.map((t) => (
              <div key={t.label} className="flex items-center gap-3 border-b border-[#F8FAFC] px-3.5 py-2.5 last:border-0">
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg border ${
                    t.dir === "out"
                      ? "border-[#E2E8F0] bg-[#F8FAFC] text-[#2563EB]"
                      : "border-teal-100 bg-teal-50 text-[#0EA5A4]"
                  }`}
                >
                  {t.dir === "out" ? <ArrowUpRight className="h-3.5 w-3.5" /> : <ArrowDownLeft className="h-3.5 w-3.5" />}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-[12px] font-medium text-[#1D305B]">{t.label}</p>
                  <p className="text-[10.5px] text-[#94A3B8]">{t.detail}</p>
                </div>
                <p className="font-mono-brand text-[11.5px] font-medium text-[#1D305B]">{t.amt}</p>
                <span className={`rounded-full border px-2 py-0.5 text-[10px] font-semibold ${STATUS[t.status]}`}>{t.status}</span>
              </div>
            ))}
          </div>

          {/* issued card */}
          <div className="flex flex-col justify-between rounded-xl bg-[#1D305B] p-4 lg:col-span-2">
            <div className="flex items-center justify-between">
              <span className="text-[11px] font-semibold text-white/80">iJeeva Issuing</span>
              <CreditCard className="h-4 w-4 text-[#5EEAD4]" />
            </div>
            <div className="mt-6">
              <div className="h-6 w-9 rounded-md border border-[#5EEAD4]/40 bg-[#5EEAD4]/10" />
              <p className="font-mono-brand mt-3 text-[13px] tracking-[0.14em] text-white">5312 •••• •••• 4412</p>
              <div className="mt-2 flex items-center justify-between text-[10px] text-white/50">
                <span>MERIDIAN OPS</span>
                <span>VIRTUAL</span>
              </div>
            </div>
            <p className="mt-4 text-[10.5px] leading-relaxed text-white/40">
              Cards issued directly from wallet balances with programmable controls.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
